<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="my-xl mx">

    <well-action-inputs #actionForm
                        [action]="action"
                        [meta]="meta"
                        [subscriptionTypeUuid]="subscriptionTypeUuid"
                        (save)="onActionSubmit($event)" data-testid="action-inputs-input">

    </well-action-inputs>

    <div class="mt pull-right">
      <button (click)="this.goBack()" [label]="'company.utils.cancel' | translate" class="mr-sm flat p-button-text"
              pButton type="button" data-testid="go-back-btn"></button>
      <button pButton [label]="'company.utils.save' | translate" type="submit"
              (click)="actionForm.onSubmit()" data-testid="action-form-on-submit-btn"></button>
    </div>

</div>


